import { MessageSquare } from 'lucide-react';

interface Props {
  className?: string;
}

export function FeedbackButton({ className = '' }: Props) {
  const handleClick = () => {
    window.open('https://fs23.formsite.com/TSCINC/vyx166x1sy/index', '_blank', 'noopener,noreferrer');
    window.dispatchEvent(new CustomEvent('feedbackOpened'));
  };

  return (
    <button
      onClick={handleClick}
      className={`w-10 h-10 md:w-auto md:h-auto md:px-3 md:py-2 rounded-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white shadow-lg hover:shadow-xl transition-all focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 flex items-center justify-center md:gap-1.5 ${className}`}
      aria-label="Give Feedback"
      title="Share your feedback on the new shop experience"
    >
      <MessageSquare className="w-5 h-5 md:w-4 md:h-4" aria-hidden="true" />
      <span className="hidden md:inline text-xs font-medium">Share Feedback</span>
    </button>
  );
}
